interface Props {
  data: string
  maxSize: number
  prefix: string
}
export const chunk = ({
  data,
  maxSize,
  prefix,
}: Props): Record<string, string> => {
  const chunks: Record<string, string> = {}
  for (let i = 0; i < data.length; i += maxSize) {
    const partNumber = i / maxSize + 1
    chunks[`${prefix}__${partNumber}`] = data.slice(i, i + maxSize)
  }
  return chunks
}
